import { type HTMLAttributes } from 'react';
import Link from 'next/link';
import clsx from 'clsx';

import { cloudinaryUrl, formatDate } from '@/utils/utils';
import { Hx } from '@/stories/atoms/Hx/Hx';

import styles from './news-card.module.css';
import { Tag } from '@/stories/atoms/Tag/Tag';
import { AgenceArticleService, AgenceArticleType } from '@/domains/agenceArticle/agenceArticle.types';
import { Row } from '@/stories/organisms/Grid/Row';
import { getArticleUrl, serviceMapping } from '@/domains/agenceArticle/agenceArticle.utils';

type FullProps = {
  variant: 'full',
  agence: string
}

type InlineProps = {
  variant?: 'inline'
  agence?: string
}

export type NewsCardProps = {
  photo?: {
    src?: string,
    alt?: string
  },
  title: string,
  date?: string,
  type: AgenceArticleType,
  slug: string
  services?: AgenceArticleService[]
} & (FullProps | InlineProps) & HTMLAttributes<HTMLElement>

export const NewsCard = ({title, date, photo, type, slug, services, variant, ...props }: NewsCardProps)=> {
  const url = getArticleUrl(type, slug)

  return (
    <div className={styles.wrapper}>
      <div className={styles.imgWpr}>
        {photo && photo.src && (
          <Link href={url || ''}>
            <img
              className={styles.image}
              src={cloudinaryUrl({src: photo.src, width: 243, params: ['h_182']})}
              sizes='(min-width: 768px) 276px, calc(100vw - 32px)'
              srcSet={`
                ${cloudinaryUrl({src: photo.src, width: 375, params: ['h_280']})} 375w,
                ${cloudinaryUrl({src: photo.src, width: 750, params: ['h_560']})} 750w,
                ${cloudinaryUrl({src: photo.src, width: 276, params: ['h_195']})} 276w,
                ${cloudinaryUrl({src: photo.src, width: 552, params: ['h_391']})} 552w
                `}
              width={243}
              height={182}
              alt={photo.alt || title}
              {...props}
              />
          </Link>
        )}
        <Tag variant='transparent' className={styles.type}>{type}</Tag>
      </div>
      <div className={clsx(styles.content)}>
        <Hx headingLevel='h3' className={styles.title}>
          <Link href={url || ''}>{title}</Link>
        </Hx>
        {services && services.length > 0 && (
          <Row>
            {services.map(service => <Tag size="small" key={service}>{serviceMapping[service]}</Tag>)}
          </Row>
        )}
        {date && <span className={styles.date}>{formatDate(date)}</span>}
      </div>
    </div>
  )
};
